<template>
  <div class="field-container">
    <div ref="field" class="field" :style="style">
      <resize-observer @notify="setWidth()" />
      <v-btn
        v-if="edit"
        color="primary"
        dark
        flat
        icon
        absolute
        top
        right
        style="background: white; margin-top: 36px"
        @click="$emit('setLineUp')"
      >
        <v-icon>edit</v-icon>
      </v-btn>

      <template v-for="(player, index) of playersLineUp">
        <player
          :key="player.position + index"
          :player="player"
          :base-width="width"
          :primary-color="primaryColor || '#00A82D'"
          :secondary-color="secondaryColor || '#FFFFFF'"
          @click="$emit('setLineUp', player)"
        />
      </template>
    </div>
  </div>
</template>
<script>
import Player from './Player'
import locations from './locations'

export default {
  components: {
    Player,
  },
  props: {
    lineUp: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    formation: {
      type: String,
      required: false,
      default: '',
    },
    primaryColor: {
      type: String,
      required: false,
      default: '#00A82D',
    },
    secondaryColor: {
      type: String,
      required: false,
      default: '#FFFFFF',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      width: 0,
    }
  },
  computed: {
    playersLineUp() {
      if (this.loading) return []
      let playersLineUp = []
      const formation = locations(this.width, this.height)[this.formation]
      if (formation) {
        Object.keys(formation).forEach((position) => {
          let item = this.lineUp[position] || { position }
          playersLineUp.push({ ...item, location: formation[position] })
        })
      }

      return playersLineUp
    },
    style() {
      return `background-image:url(${require('@/assets/images/lineup/soccer_field_FBASE.png')});
              background-size: 100% ${this.height}px;
              height: ${this.height}px;
              width: 100%
          `
    },
    height() {
      return this.width * 1.5
    },
  },
  mounted() {
    this.setWidth()
  },
  methods: {
    setWidth() {
      this.$nextTick(() => {
        if (this.$refs.field && this.$refs.field.clientWidth) {
          this.width = this.$refs.field.clientWidth
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.field-container {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  @media screen and (max-width: 600px) {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-direction: column;
    align-items: center;
    // -webkit-transform: scale(0.8);
    // transform: scale(0.8);
    // margin-top: -60px;
  }

  @media screen and (max-width: 405px) {
    // -webkit-transform: scale(0.72);
    // transform: scale(0.72);
    // margin-top: -84px;
  }
  .field {
    background-repeat: no-repeat;
    position: relative;
  }
}
</style>
